import { isTruthy } from '@feedyou/utils'
import { DropdownMenuItem } from './Item/types'

export function hasSubItems(itemOrList?: DropdownMenuItem | DropdownMenuItem[] | false): boolean {
  if (!itemOrList) {
    return false
  }

  if (Array.isArray(itemOrList)) {
    return itemOrList.some(hasSubItems)
  }

  return !!itemOrList.submenuItems && itemOrList.submenuItems.some(isTruthy)
}
